var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"booklist"},_vm._l((_vm.value),function(book,i){return _c('div',{key:i,staticClass:"item",on:{"click":function($event){_vm.read(book, i)}}},[_c('span',[_vm._v(_vm._s(book.name))])])}))}
var staticRenderFns = []

export { render, staticRenderFns }